import React from "react";

import Root from "./Root";

import "shared/assets/styles/styles.scss";

const App: React.FC = () => <Root />;

export default App;
